import { useState, useEffect } from 'react';
import { Dialog } from "@mui/material";

export const ConfirmationPopup = ({ 
  isOpen = true, 
  onClose, 
  onContinue, 
  title = "Continue", 
  description = "Would you like to continue?",
  continueText = "Continue",
  cancelText = "Cancel",
  children 
}) => {

  
  // Handle animation timing
  useEffect(() => {
   
  }, []);
  

  
  return (
    // <div className={`fixed inset-0 z-50 flex bg-red-200 items-center justify-center p-4 transition-all duration-200 ${isOpen ? 'bg-black/50 backdrop-blur-sm' : 'bg-black/0 pointer-events-none'}`}>
    <Dialog
      open={isOpen}
      onClose={()=>{
       
      }
    }
      fullWidth
      sx={{
        "& .MuiPaper-root ": {
        //   maxWidth: "660px",
          margin: "0 auto",
        },
      }}
    >
      {/* {authForm[authStep]} */}
   
      <div 
        className={`bg-white rounded-lg shadow-xl w-full transition-all duration-200 relative ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Close"
        >
            X
          {/* <X size={20} /> */}
        </button>
        
        {/* Modal content */}
        <div className="p-6">
          {/* Title */}
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            {title}
          </h3>
          
          {/* Description */}
          <p className="text-sm text-gray-500 mb-4">
            {description}
          </p>
          
          {/* Custom content */}
          {children && (
            <div className="mb-6">
              {children}
            </div>
          )}
          
          {/* Actions */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={() => {
                onContinue();
                onClose();
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-[#ee4b2b] rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
            >
              {continueText}
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

